import { render, staticRenderFns } from "./MFormVuetifyStaffPicker.vue?vue&type=template&id=a1c3e6c2"
import script from "./MFormVuetifyStaffPicker.vue?vue&type=script&lang=js"
export * from "./MFormVuetifyStaffPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports